import * as React from 'react'
import styled from 'styled-components'
import NPCseal from '../../../assets/img/npc-seal/npc-seal-july2025.png'

const Description = styled.div`
  font-size: 0.875rem;
  margin: 0px auto;
  max-width: 800px;

  table {
    border-collapse: collapse;
    margin: 1rem auto;
  }

  table td,
  table th {
    border: 1px solid;
    padding: 0.5em 1em;
  }

  .ropa-table {
    width: 100%;
  }

  .ropa-table th {
    background: #06245f;
    color: #ffffff;
    text-align: center;
  }

  .ropa-table td {
    vertical-align: middle;
  }

  .ropa-table.privacy-use-table th:first-child,
  .ropa-table.privacy-use-table td:first-child {
    width: 38%;
  }

  .ropa-table.privacy-use-table td {
    font-weight: 400;
  }

  .ropa-table.privacy-use-table td:first-child {
    font-weight: 700;
  }

  .npc-seal-container {
    text-align: center;
  }
  img#npc-seal {
    height: 300px;
  }
`
const emailContact = 'ayalamallsdataprivacy' + '@' + 'ayalamalls.com.ph'

export const PrivacyPolicyTitle = () => `Ayala Malls Website Privacy Notice`

// ST-1615 update Ayala Privacy Notice
export const descriptionData = (
  <>
    <div class="npc-seal-container">
      <img id="npc-seal" src={NPCseal} alt="NPC Seal" />
    </div>

    <h2>ZING APP: PRIVACY NOTICE</h2>

    <p>
      <b>Effective Date:</b> Apr 21, 2026 | <b>Last Reviewed:</b> Apr 21, 2026
    </p>

    <h2>1. YOUR PRIVACY AT A GLANCE</h2>
    <ul>
      <li>
        <b>Who we are:</b> AyalaLand Malls, Inc. (ALMI) is the Personal
        Information Controller (PIC)—the legal entity responsible for processing
        and protecting your personal data.
      </li>
      <li>
        <b>What we do:</b> We provide the <b>Zing App</b> for the purpose of
        serving as your <b>Digital Mall Companion</b>.
      </li>
      <li>
        <b>Why we collect data:</b> We process your information primarily based
        on <b>Contractual Necessity</b> under the Philippine Data Privacy Act of
        2012 (Philippine DPA).
      </li>
      <li>
        <b>Our "Big Rule": We do not sell your personal data.</b> We only share
        it with specialized third-party service providers strictly as necessary
        to provide the services of the Zing App.
      </li>
    </ul>

    <h2>2. WHEN &amp; HOW WE COLLECT DATA</h2>
    <p>
      We collect your information through various electronic channels to make
      our services possible:
    </p>
    <ul>
      <li>
        <b>Account Registration (Electronic):</b> Triggered when you sign up for
        Zing, we collect your Name, Mobile Number, and Email primarily to
        establish and manage your identity.
      </li>
      <li>
        <b>Wayfinding Utility (Electronic):</b> Triggered when you use the app’s
        navigation features, we show suggested routes based on our mall map
        data. To help identify the nearest mall, the app may use your device’s
        approximate location. We do not collect or store your exact indoor
        location or your route history.
      </li>
      <li>
        <b>System-Generated Data (Electronic):</b> Triggered automatically when
        you use the platform, we collect technical logs, IP addresses, and
        timestamps to ensure system security and performance.
      </li>
    </ul>

    <h2>3. HOW WE USE YOUR INFORMATION</h2>
    <p>
      We process your personal data only when the law (Philippine DPA) allows us
      to. The table below outlines our primary processing activities:
    </p>

    <table className="ropa-table privacy-use-table">
      <thead>
        <tr>
          <th>Why we use your data (Purposes)</th>
          <th>Data Categories Used</th>
          <th>Our Legal Authority (Lawful Basis)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Account Management &amp; ID</td>
          <td>Name, Email</td>
          <td>Contractual Necessity</td>
        </tr>
        <tr>
          <td>Identity Security &amp; MFA</td>
          <td>Mobile Number</td>
          <td>Contractual Necessity</td>
        </tr>
        <tr>
          <td>Automatic Mall Selection</td>
          <td>Location Proximity</td>
          <td>Contractual Necessity</td>
        </tr>
        <tr>
          <td>Security Auditing &amp; Performance</td>
          <td>Technical &amp; Access Logs</td>
          <td>Legitimate Interest</td>
        </tr>
      </tbody>
    </table>
    <p>
      We do not perform <b>“Automated Decision-Making”</b> that has legal
      effects or significantly affects you.
    </p>

    <h2>4. WHERE YOUR DATA LIVES</h2>
    <p>
      To provide a secure digital service, your personal data is processed as
      follows:
    </p>

    <ul>
      <li>
        <b>Host Locations:</b> Our secure "digital vaults" (data centers and
        cloud infrastructure) are located in <b>Singapore</b> (AWS) and{' '}
        <b>Canada</b>
        (MappedIn) to host the platform.{' '}
      </li>
      <li>
        <b>Safety Standards:</b> All international data transfers are governed
        by <b>Data Processing Agreements (DPAs)</b>. These ensure that your
        personal data is protected just as strongly as it is required under the
        Philippine DPA.
      </li>
      <li>
        <b>Sub-processors:</b> Our third-party partners are strictly vetted to
        ensure they maintain high-standard technical, physical, and
        organizational security measures.
      </li>
    </ul>

    <h2>5. HOW WE KEEP YOUR DATA SAFE</h2>
    <p>
      We implement a <b>"Defense in Depth"</b>—multiple layers of security to
      keep your personal data private:
    </p>

    <ul>
      <li>
        <b>Technical Controls:</b> We use{' '}
        <b>Transport Layer Security (TLS 1.3) encryption </b>
        to scramble your data while it travels and require{' '}
        <b>Multi-Factor Authentication (MFA)</b> to prevent unauthorized access.{' '}
      </li>
      <li>
        <b>Organizational Rules:</b> Access is strictly restricted to authorized
        personnel via Identity Management systems with strict audit logging. All
        employees and processors are bound by confidentiality agreements.
      </li>
      <li>
        <b>Physical & Infrastructure Security:</b> Your data is kept in{' '}
        <b>Tier-3 Data Centers</b>. For you, this means your data is stored in a
        facility with "redundant" systems—meaning it has multiple backup power
        sources and cooling systems. This ensures that even during a major power
        outage or technical failure, your data remains safe, available, and
        protected from physical threats 24/7.
      </li>
    </ul>

    <h2>6. DO WE USE COOKIES?</h2>
    <p>
      Yes. We use small digital files called “cookies” and similar tracking
      technologies to help the site work properly:
    </p>

    <ul>
      <li>
        <b>Strictly Necessary: </b>Essential for the platform to allow you to
        log in and use Multi-Factor Authentication (MFA).
      </li>
      <li>
        <b>Security & Performance:</b> These help us detect fraudulent activity
        and ensure the app stays up and running.
      </li>
      <li>
        <b>Note:</b> You can turn cookies off in your browser settings, but the
        site might not work correctly if you do.
      </li>
    </ul>

    <h2>7. WHEN DO WE DELETE YOUR DATA?</h2>
    <p>
      We believe in <b>Data Minimization</b>—we don't keep what we don’t need.
    </p>

    <ul>
      <li>
        <b>Our Timeline:</b> If you request account deletion, your data is{' '}
        <b>immediately removed</b>. Otherwise, we typically hold records for{' '}
        <b>2 years</b> of inactivity.{' '}
      </li>
      <li>
        <b>The Final Step:</b> After this period expires, we ensure that your
        personal data is either <b>permanently deleted</b> or{' '}
        <b>fully anonymized</b>.{' '}
      </li>
      <li>
        <b>A Few Exceptions:</b> We may keep certain details longer (up to{' '}
        <b>10 years</b>) if needed to defend against a legal claim under the
        Philippine Civil Code.{' '}
      </li>
    </ul>

    <h2>8. YOUR DATA PRIVACY RIGHTS</h2>
    <p>
      You are in the driver’s seat. Under the Philippine Data Privacy Act of
      2012, you have the right to:
    </p>

    <ul>
      <li>
        <b>Be Informed:</b> Understand how your data is being collected and
        used. This Notice serves that purpose.{' '}
      </li>
      <li>
        <b>Access & Portability:</b> Request a copy of the personal data we hold
        about you in a common, machine-readable format. We may charge a
        reasonable administrative fee.{' '}
      </li>
      <li>
        <b>Rectify:</b> Correct any inaccurate information or outdated data.
      </li>
      <li>
        <b>Object:</b> Stop the processing of your data for direct marketing or
        Automated Decision-Making activities, unless we can demonstrate that the
        processing is required by law or to fulfill our contract with you.
      </li>
      <li>
        <b>Erasure:</b> Request that we delete your personal data. Please
        understand that this right is not absolute; we may be required by law to
        retain certain records for tax, audit, or legal defense purposes (e.g.,
        Civil Code prescriptions).{' '}
      </li>
      <li>
        <b>File a Complaint:</b> Raise a complaint about a violation of your
        data privacy rights. Please tell us first through
        <b> ayalamallsdataprivacy@ayalamalls.com.ph</b>, so we have a chance to
        address your concerns. If we fail in this, you can address any complaint
        to the National Privacy Commission (NPC).{' '}
      </li>
      <li>
        <b>Damages:</b> Seek indemnity for verifiable damages sustained due to a
        violation of your rights, subject to a final decision by the NPC or the
        courts.
      </li>
    </ul>

    <h2>9. YOUR ROLE IN STAYING SECURE</h2>
    <p>Privacy is a partnership. To keep your account safe, we need you to:</p>

    <ul>
      <li>
        <b>Be Accurate:</b> Provide us true and updated personal data, and let
        us know if your contact details change to ensure you continue receiving
        critical alerts.
      </li>
      <li>
        <b>Guard Your MFA Codes:</b> Never share your Multi-Factor
        Authentication (MFA) codes with anyone, including people claiming to be
        from our team.
      </li>
      <li>
        <b>Report Suspicious Activity:</b> Tell us immediately at
        <b> ayalamallsdataprivacy@ayalamalls.com.ph</b> if you think your
        account has been compromised.
      </li>
    </ul>

    <h2>10. CONTACT OUR PRIVACY TEAM</h2>
    <p>
      If you have any questions, concerns, or requests regarding your personal
      data, or if you wish to exercise your rights under the Philippine Data
      Privacy Act, please reach out to our Data Protection Officer at
      <b> ayalamallsdataprivacy@ayalamalls.com.ph.</b>
    </p>
  </>
)

export const PrivacyPolicyDescription = () => (
  <Description>{descriptionData}</Description>
)

function PrivacyPolicy(props) {
  return (
    <aside {...props}>
      <PrivacyPolicyDescription />
    </aside>
  )
}

export default PrivacyPolicy
